import { render, staticRenderFns } from "./FreeModeCourse.vue?vue&type=template&id=39d21bcc&"
import script from "@/scripts/FreeMode/FreeModeCourse/index.js?vue&type=script&lang=js&"
export * from "@/scripts/FreeMode/FreeModeCourse/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports